export enum Stages{
    PartnerApproval = 4,
    AccountsApproval = 5,
    PartnerAuthorise = 6,
    FinalAccountsApproval = 7
}

export const StagesLabel: { [key: number]: string } = {
    4: 'Commented by Partner',
    5: 'Commented by Accounts',
    6: 'Commented by Partner while authorizing the request',
    7: 'Commented by Accounts while releasing the funds',
};
